import React from 'react';
import { StarIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function TestimonialsSection() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAddToCart();
    window.location.href = 'https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1';
  };
  const testimonials = [{
    name: 'Mariana G.',
    text: 'Intenté aprender crochet mil veces y siempre terminaba frustrada… hasta que encontré este ebook. La forma en la que explica es súper clara, paso a paso. En pocos días ya estaba haciendo mis primeros amigurumis sin estrés. Hoy no solo disfruto tejer, ¡sino que me siento orgullosa de lo que hago!',
    rating: 5
  }, {
    name: 'Laura M.',
    text: 'Lo que más me sorprendió fue lo fácil que es seguir los patrones. Antes me perdía todo el tiempo, ahora entiendo cada paso y avanzo sin dudas. Es la primera vez que termino proyectos y me quedan lindos de verdad.',
    rating: 5
  }, {
    name: 'Carla R.',
    text: 'Compré el ebook sin muchas expectativas… pero me cambió totalmente la forma de tejer. Pasé de no saber por dónde empezar, a crear amigurumis que ahora hasta estoy vendiendo. De verdad vale cada peso.',
    rating: 5
  }, {
    name: 'Sofía L.',
    text: "Siempre veía cosas hermosas en Pinterest y pensaba 'yo no puedo hacer eso'. Con este ebook me di cuenta de que sí podía, solo necesitaba una buena guía. Hoy ya hice varios muñequitos y todos me preguntan dónde los compré.",
    rating: 5
  }, {
    name: 'Valentina P.',
    text: 'Me encanta porque no es solo aprender crochet… también te abre la cabeza a que podés generar ingresos con esto. Ya vendí mis primeros amigurumis y no lo puedo creer. Si estás dudando, te diría que lo compres sin pensarlo.',
    rating: 5
  }];
  return <section className="w-full py-16 px-4 bg-gradient-to-b from-cream to-white" data-id="element-120">
      <div className="max-w-6xl mx-auto" data-id="element-121">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-center text-gray-900 mb-4" data-id="element-122">
          ⭐ Más de 3.700 tejedoras ya están aprendiendo
        </h2>
        <p className="font-body text-lg text-center text-gray-600 mb-12" data-id="element-123">
          Lee lo que dicen nuestras alumnas:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-124">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow" data-id="element-125">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-126">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-accent text-accent" aria-hidden="true" data-id="element-127" />)}
              </div>

              {/* Testimonial Text */}
              <p className="font-body text-gray-700 text-base leading-relaxed mb-4" data-id="element-128">
                "{testimonial.text}"
              </p>

              {/* Name */}
              <p className="font-heading font-semibold text-gray-900" data-id="element-129">
                — {testimonial.name}
              </p>
            </div>)}
        </div>

        {/* Final CTA */}
        <div className="mt-12 text-center" data-id="element-130">
          <a href="https://tejeyemprende.store/cart/add?id=52432487153961&quantity=1" onClick={handleCTAClick} className="inline-block bg-primary hover:bg-opacity-90 text-white font-heading font-bold text-xl px-12 py-5 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105" data-id="element-131">
            QUIERO EMPEZAR AHORA
          </a>
        </div>
      </div>
    </section>;
}